module.exports = __webpack_public_path__ + "static/media/vertical_farm.691facf2.jpg";